import Vue from 'vue';
import Vuex from 'vuex';

import { appState } from './modules/appState.js'
import { gpsstModule } from './modules/gpsstModule.js'


Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    gpsstModule,
    appState
  }
});